import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Auth from "@/utils/Auth";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css";

import Layout from "@/views/Layout";
import Index from "@/views/Index.vue";
import errorPageOne from "@/views/errorPage/401.vue";
import errorPageFour from "@/views/errorPage/404.vue";
import BigScreen from "@/views/BigScreen";

import RoomCreate from "@/views/TrtcRoom/RoomCreate";
import RoomEnter from "@/views/TrtcRoom/RoomEnter";
import MessageCenter from "@/views/MessageCenter";
import MessageNotice from "@/views/MessageNotice";
import MyCollection from "@/views/MyCollection"
import PersonInfo from "@/views/PersonInfo";

// import HelpCenter from "@/views/HelpCenter/HelpCenter";
// import SystemConfig from "@/views/HelpCenter/SystemConfig";
// import FunctionalModule from "@/views/HelpCenter/FunctionalModule";
// import FAQ from "@/views/HelpCenter/FAQ";

import News from "@/views/News.vue";
import Customize from "@/views/Customize.vue";
import NewsDetail from "@/views/NewsDetail.vue";
import CustomizeDetail from "@/views/CustomizeDetail.vue";
import Interviews from "@/views/Interviews.vue";
import InterviewsDetail from "@/views/InterviewsDetail.vue";
import Teachers from "@/views/Teachers.vue";
import TeacherDetail from "@/views/TeacherDetail.vue";
import OpenResource from "@/views/OpenResource.vue";
import OpenResourceDetail from "@/views/OpenResourceDetail.vue";
import introduction from "@/views/introduction.vue";

const whiteList = [
    // 白名单,不需要登录的路由
    "/Index",
    "/News",
    "/Customize",
    "/NewsDetail",
    "/CustomizeDetail",
    "/Interviews",
    "/InterviewsDetail",
    "/Teachers",
    "/TeacherDetail",
    "/OpenResource",
    "/OpenResourceDetail",
    "/BigScreen",
    // "/HelpCenter",
    // "/HelpCenter/SystemConfig",
    // "/HelpCenter/FunctionalModule",
    // "/HelpCenter/FAQ",
    "/404",
    "/401",
    "/introduction",
];

Vue.use(Router);

const constantRouterMap = [
    {
        path: "/",
        redirect: "/Index",
    },
    {
        path: "/401",
        name: "401",
        component: errorPageOne,
    },
    {
        path: "/404",
        name: "404",
        component: errorPageFour,
    },
    {
        path: "/BigScreen",
        name: "BigScreen",
        component: BigScreen,
    },
    {
        path: "/RoomCreate",
        name: "创建房间",
        component: RoomCreate,
    },
    {
        path: "/RoomEnter",
        name: "进入房间",
        component: RoomEnter,
    },
    {
        path: "/",
        name: "layout",
        component: Layout,
        children: [
            {
                path: "Index",
                name: "首页",
                component: Index,
            },
            {
                path: "/News",
                name: "新闻中心",
                component: News,
            },
            {
                path: "/Customize",
                name: "自定义数据",
                component: Customize,
            },
            {
                path: "/CustomizeDetail",
                name: "自定义数据详情",
                component: CustomizeDetail,
            },
            {
                path: "/NewsDetail",
                name: "新闻中心详情",
                component: NewsDetail,
            },
            {
                path: "/Interviews",
                name: "精英采访",
                component: Interviews,
            },
            {
                path: "/InterviewsDetail",
                name: "精英采访详情",
                component: InterviewsDetail,
            },
            {
                path: "/Teachers",
                name: "师资阵容",
                component: Teachers,
            },
            {
                path: "/TeacherDetail",
                name: "师资阵容详情",
                component: TeacherDetail,
            },
            {
                path: "/OpenResource",
                name: "公开资源",
                component: OpenResource,
            },
            {
                path: "/OpenResourceDetail",
                name: "公开资源详情",
                component: OpenResourceDetail,
            },
            {
                path: "/MessageCenter",
                name: "消息中心",
                component: MessageCenter,
            },
            {
              path: "/MyCollection",
              name: "我的收藏",
              component: MyCollection,
          },
            {
                path: "/MessageNotice",
                name: "发布通知",
                component: MessageNotice,
            },
            {
                path: "/PersonInfo",
                name: "个人中心",
                component: PersonInfo,
            },
            // {
            //     path: "/HelpCenter",
            //     name: "帮助中心",
            //     component: HelpCenter,
            //     children: [
            //         {
            //             path: "SystemConfig",
            //             name: "系统配置",
            //             component: SystemConfig,
            //         },
            //         {
            //             path: "FunctionalModule",
            //             name: "功能模块",
            //             component: FunctionalModule,
            //         },
            //         {
            //             path: "FAQ",
            //             name: "热门疑问",
            //             component: FAQ,
            //         },
            //     ],
            // },
            {
                path: "/introduction",
                name: "学校介绍",
                component: introduction,
            },
        ],
    },
];

const asyncRouterMap = [];

let router = new Router({
    routes: constantRouterMap,
});

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (Auth.getToken()) {
        // console.log("to--A-->", to);
        let _userInfo = store.state.user.userInfo;
        if (_userInfo.roleId == 100 || _userInfo.roleId == 101) {
            // console.log("to--B-->", to);
            next();
        } else if (
            _userInfo.roleId != null &&
            _userInfo.roleId != 100 &&
            _userInfo.roleId != 101
        ) {
            next();
        } else {
            store.dispatch("generationRouters").then((res) => {
                // console.log("to--C-->", to);
                next({ ...to });
            });
        }
    } else if (whiteList.indexOf(to.path) !== -1) {
        console.log(whiteList.indexOf(to.path));
        // console.log("to--D-->", to);
        next();
    } else {
        // console.log("to--E-->", to);
        next({ path: "/401" });
    }
});

router.afterEach((to, from, next) => {
    NProgress.done();
});

export default router;

/*
else if (_userInfo.roleId == 102){
    console.log("to--F-->", to);
    next({ path: "/401" });
}
*/
